import styled from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const TitleContent = styled.h1`
  width: 100%;
  font-weight: bold;
  ${fontSize(12)};
  ${media.desktop`
    ${fontSize(18)};
  `};
`;
